import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { FirebaseAuthService } from "../../noizu/services/firebase-auth.service";
import { AppengineRepo } from "../appengine.repo";
import { UserLocationEntity } from "../../entities/user/location.entity";

@Injectable()
export class UserLocationRepo extends AppengineRepo {
  public _kind = "locations";
  public _singular = "location";

  constructor(
    @Inject(HttpClient) client: HttpClient,
    @Inject(FirebaseAuthService) auth: FirebaseAuthService
  ) {
    super(client, auth);
  }

  entity(record) {
    return new UserLocationEntity(this.client, this.auth, record);
  }

  getUserListPromise(userIdentifier: string, options = {}) {
    let url = `${this.apiBase()}/user/${userIdentifier}/locations`;
    return this._getListPromise(
      url,
      (record) => {
        return this.entity(record);
      },
      options
    );
  }
}
